<template>
  <div class="dashboard-resident-vital-signs-list">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container-fluid">
      <div class="row pl-3 pt-3 pr-3 pb-0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h1 class="title-pages pl-0 check-text-center">RESIDENTES</h1>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pt-0 pb-0">
          <p class="mb-3 text-one">
            <i class="fas fa-filter mr-2 text-twenty icon-search"></i> Filtrar
          </p>
          <v-select
            dense
            :items="genders"
            v-model="gender"
            label="Gênero"
            outlined
            @change="getResidents"
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pt-0 pb-0">
          <p class="mb-3 text-one">
            <i class="fas fa-search mr-1 icon-search"></i> Pesquisar
          </p>
          <v-text-field
            dense
            placeholder="Nome do residente"
            label="Nome do residente"
            outlined
            v-model="name"
            @input="getResidents"
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pt-0 pb-0">
          <p class="mb-3 text-one">
            <i class="fas fa-filter mr-2 text-twenty icon-search"></i> Filtrar
          </p>
          <v-select
            dense
            :items="typesFilterByGrau"
            v-model="degree_of_dependence_id"
            label="Grau de dependência"
            outlined
            @change="getResidents"
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pt-0 pb-0">
          <p class="mb-3 text-one">
            <i class="fas fa-filter mr-2 text-twenty icon-search"></i> Filtrar
          </p>
          <v-select
            style="z-index: 999 !important"
            @input="getResidents"
            label="FILTRAR PRÓXIMAS/ANTERIORES"
            v-model="next_or_previous"
            :items="[
              { value: 'PREV', text: 'DATAS ANTERIORES' },
              { value: 'NEXT', text: 'PRÓXIMAS DATAS' },
            ]"
            dense
            outlined
            item-value="value"
            item-text="text"
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pt-0 pb-0">
          <p class="mb-3 text-one">
            <i class="fas fa-filter mr-2 text-twenty icon-search"></i> Filtrar
          </p>
          <v-text-field
            label="DATA"
            outlined
            dense
            type="date"
            v-model="date"
            @input="getResidents"
          />
        </div>
      </div>
      <b-overlay class="pl-2 pt-0 pr-2" :show="loading" opacity="0.99">
        <div v-for="resident in residents" :key="resident.id" class="mb-2 p-2">
          <div class="d-flex align-items-center border p-2">
            <img
              class="photo-url mr-2"
              :src="
                permission('read', 'resident_photo') && resident.photo_url
                  ? resident.photo_url
                  : require('../assets/user.png')
              "
            />
            <h5 class="text-fifteen m-0 upper-text mr-2">
              {{ resident.name }}
              <p
                class="worksansr upper-text text-fifteen m-0"
                v-if="resident.date_of_birth"
              >
                {{ getAge(resident.date_of_birth) }} ANOS
              </p>
            </h5>
            <button
              class="btn-filter p-2"
              @click="handleToResident(resident.id)"
            >
              Acessar residente
            </button>
          </div>
          <div>
            <table class="table table-responsive table-bordered tableFixHead">
              <thead>
                <tr>
                  <th class="text-two text-center">MEDIÇÃO VITAL</th>
                  <th
                    class="text-center"
                    v-for="item in resident.vital_signs"
                    :key="item.date"
                  >
                    {{ formatDate(item.date, false) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="type in typesVitalSigns" :key="type.type">
                  <td
                    style="width: 10% !important"
                    class="text-two text-center"
                  >
                    <strong>{{ type }}</strong>
                  </td>
                  <td
                    v-for="(vital_sign, key) in resident.vital_signs"
                    :key="key"
                  >
                    <div
                      class="text-center text-thirteen"
                      v-if="
                        vital_sign.care_vital_signs.length == 0 &&
                        vital_sign.care_has_feeding_care.length == 0
                      "
                    >
                      --
                    </div>
                    <div
                      v-if="
                        type == TYPE_ALIMENTACAO &&
                        vital_sign.care_has_feeding_care.length > 0
                      "
                    >
                      <div
                        class="text-center"
                        v-for="item in vital_sign.care_has_feeding_care"
                        :key="item.id"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            item.response == 'BOA ACEITAÇÃO' &&
                              'bg-success text-white',
                            item.response == 'ACEITOU PARCIAL' &&
                              'bg-warning text-dark',
                            item.response == 'NÃO ACEITOU' &&
                              'bg-danger text-white',
                          ]"
                          :content="`
                            ${formatDate(item.created_at)} 
                            -
                            ${item.name}
                            -
                            ${item.response}
                            <br />
                            CADASTRADO POR: ${item.user_name}`"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ item.name }} - {{ item.response }}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="text-center"
                      v-for="(
                        care_vital_sign, index
                      ) in vital_sign.care_vital_signs"
                      :key="index"
                    >
                      <div
                        v-for="item in care_vital_sign.care_has_vital_signs"
                        :key="item.id"
                        v-show="item.type == type"
                      >
                        <div v-if="type == TYPE_DIURESE">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="[
                                'mb-1 border-for btn-block',
                                item.description == 'POUCA DIURESE' &&
                                  'bg-warning text-dark',
                                item.description == 'DIURESE PRESENTE' &&
                                  'bg-success text-white',
                                item.description == 'AUSÊNCIA DE DIURESE' &&
                                  'bg-danger text-white',
                              ]"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${item.description}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}
                                  `"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ item.description }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-if="type == TYPE_DOR">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="[
                                'mb-1 border-for btn-block',
                                parseInt(item.description) >= 0 &&
                                  parseInt(item.description) <= 3 &&
                                  'bg-success text-white',
                                parseInt(item.description) >= 4 &&
                                  parseInt(item.description) <= 7 &&
                                  'bg-warning text-dark',
                                parseInt(item.description) >= 8 &&
                                  parseInt(item.description) <= 10 &&
                                  'bg-danger text-white',
                              ]"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${handleDescriptionAche(item.description)}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}`"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ handleDescriptionAche(item.description) }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-if="type == TYPE_EVACUACAO">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="[
                                'mb-1 border-for btn-block',
                                item.description == 'PASTOSA' &&
                                  'bg-warning text-dark',
                                item.description == 'EM CÍBALOS' &&
                                  'bg-warning text-dark',
                                item.description == 'BEM MOLDADAS' &&
                                  'bg-success text-white',
                                item.description == 'AUSENTE' &&
                                  'bg-danger text-white',
                                item.description == 'LÍQUIDA' &&
                                  'bg-danger text-white',
                              ]"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${item.description}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}`"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ item.description }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-if="type == TYPE_FREQUENCIA_RESPIRATORIA">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="[
                                'mb-1 border-for btn-block',
                                parseInt(item.description) >= 10 &&
                                  parseInt(item.description) <= 20 &&
                                  'bg-success text-white',
                                parseInt(item.description) >= 21 &&
                                  parseInt(item.description) <= 34 &&
                                  'bg-warning text-dark',
                                (parseInt(item.description) < 10 ||
                                  parseInt(item.description) > 34) &&
                                  'bg-danger text-white',
                              ]"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${item.description}
                                  ${item.abbreviation}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}`"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ item.description }}
                                {{ item.abbreviation }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-if="type == TYPE_GLICEMIA_CAPILAR">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="[
                                'mb-1 border-for btn-block',
                                parseInt(item.description) >= 70 &&
                                  parseInt(item.description) <= 110 &&
                                  'bg-success text-white',
                                parseInt(item.description) >= 51 &&
                                  parseInt(item.description) <= 69 &&
                                  'bg-warning text-dark',
                                parseInt(item.description) >= 111 &&
                                  parseInt(item.description) <= 125 &&
                                  'bg-warning text-dark',
                                (parseInt(item.description) >= 126 ||
                                  parseInt(item.description) <= 51) &&
                                  'bg-danger text-white',
                              ]"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${item.description}
                                  ${item.abbreviation}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}`"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ item.description }}
                                {{ item.abbreviation }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-if="type == TYPE_PRESSAO_ARTERIAL">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="[
                                'mb-1 border-for btn-block',
                                handleColorBloodPressure(
                                  item.initial_description,
                                  item.final_description
                                ),
                              ]"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${item.description}
                                  ${item.abbreviation}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}`"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ item.description }}
                                {{ item.abbreviation }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-if="type == TYPE_PULSO_FREQUENCIA_CARDIACA">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="[
                                'mb-1 border-for btn-block',
                                parseInt(item.description) >= 60 &&
                                  parseInt(item.description) <= 100 &&
                                  'bg-success text-white',
                                parseInt(item.description) >= 101 &&
                                  parseInt(item.description) <= 139 &&
                                  'bg-warning text-dark',
                                parseInt(item.description) >= 41 &&
                                  parseInt(item.description) <= 59 &&
                                  'bg-warning text-dark',
                                parseInt(item.description) >= 140 &&
                                  parseInt(item.description) <= 40 &&
                                  'bg-danger text-white',
                              ]"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${item.description}
                                  ${item.abbreviation}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}`"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ item.description }}
                                {{ item.abbreviation }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-if="type == TYPE_SATURACAO_DE_OXIGENIO">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="[
                                'mb-1 border-for btn-block',
                                parseInt(item.description) >= 92 &&
                                  parseInt(item.description) <= 100 &&
                                  'bg-success text-white',
                                parseInt(item.description) >= 88 &&
                                  parseInt(item.description) <= 91 &&
                                  'bg-warning text-dark',
                                parseInt(item.description) <= 87 &&
                                  'bg-danger text-white',
                              ]"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${item.description}
                                  ${item.abbreviation}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}`"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ item.description }}
                                {{ item.abbreviation }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-if="type == TYPE_TEMPERATURA_CORPORAL">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="[
                                'mb-1 border-for btn-block',
                                parseFloat(item.description) >= 36.1 &&
                                  parseFloat(item.description) <= 37.2 &&
                                  'bg-success text-white',
                                parseFloat(item.description) >= 37.3 &&
                                  parseFloat(item.description) <= 38.4 &&
                                  'bg-warning text-dark',
                                parseFloat(item.description) >= 35.1 &&
                                  parseFloat(item.description) <= 36 &&
                                  'bg-warning text-dark',
                                (parseFloat(item.description) > 38.4 ||
                                  parseFloat(item.description) < 35.1) &&
                                  'bg-danger text-white',
                              ]"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${item.description}
                                  ${item.abbreviation}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}`"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ item.description }}
                                {{ item.abbreviation }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-if="type == TYPE_PESO">
                          <div
                            v-if="
                              care_vital_sign.care_has_vital_signs.length > 0
                            "
                          >
                            <button
                              :class="['mb-1 border-for btn-block']"
                              :content="`
                                  ${formatDate(item.created_at)} 
                                  -
                                  ${item.description}
                                  ${item.abbreviation}
                                  <br />
                                  CADASTRADO POR: ${item.user_name}`"
                              v-tippy="{
                                followCursor: true,
                              }"
                            >
                              <span class="text-eleven upper-text">
                                {{ item.description }}
                                {{ item.abbreviation }}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <ErrorsMessages :errors="errors" />
        <div class="text-center v-clean p-5" v-show="residents.length == 0">
          <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
        </div>
      </b-overlay>
      <b-pagination
        align="center"
        v-if="residents.length > 0"
        @input="getResidents()"
        v-model="page"
        :total-rows="total"
        :per-page="itemsPerPage"
      />
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import api from "../services/api";

import { getAge } from "../lib/getAgeByDate";

import routes from "../routes";

import permission from "../lib/permission";

import { userData } from "../lib/functions";

import { formatDate } from "../lib/format";

import moment from "moment";

export default {
  name: "ResidentsVitalSignsList",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },

  data() {
    return {
      page: 1,
      total: 0,
      itemsPerPage: 10,

      next_or_previous: "PREV",
      date: moment().format("YYYY-MM-DD"),

      name: "",

      typesVitalSigns: [
        "ALIMENTAÇÃO",
        "DIURESE",
        "DOR",
        "EVACUAÇÃO",
        "FREQUÊNCIA RESPIRATÓRIA",
        "GLICEMIA CAPILAR",
        "PRESSÃO ARTERIAL",
        "PULSO (FREQUÊNCIA CARDÍACA)",
        "SATURAÇÃO DE OXIGÊNIO",
        "TEMPERATURA CORPORAL",
        "PESO",
      ],

      TYPE_ALIMENTACAO: "ALIMENTAÇÃO",
      TYPE_DIURESE: "DIURESE",
      TYPE_DOR: "DOR",
      TYPE_EVACUACAO: "EVACUAÇÃO",
      TYPE_FREQUENCIA_RESPIRATORIA: "FREQUÊNCIA RESPIRATÓRIA",
      TYPE_GLICEMIA_CAPILAR: "GLICEMIA CAPILAR",
      TYPE_PRESSAO_ARTERIAL: "PRESSÃO ARTERIAL",
      TYPE_PULSO_FREQUENCIA_CARDIACA: "PULSO (FREQUÊNCIA CARDÍACA)",
      TYPE_SATURACAO_DE_OXIGENIO: "SATURAÇÃO DE OXIGÊNIO",
      TYPE_TEMPERATURA_CORPORAL: "TEMPERATURA CORPORAL",
      TYPE_PESO: "PESO",

      gender: "NONE",
      filterCare: "NONE",
      degree_of_dependence_id: "NONE",

      filter: [],

      residents: [],

      user: {},

      typesFilterByCare: [
        { value: "NONE", text: "Todos os residentes" },
        { value: "USER", text: "Cuidados cadastrados por mim" },
        { value: "ALL", text: "Todos com cuidados pendentes" },
      ],

      typesFilterByGrau: [
        { value: "NONE", text: "Não filtrar" },
        { value: "GRAU1", text: "GRAU 1" },
        { value: "GRAU2", text: "GRAU 2" },
        { value: "GRAU3", text: "GRAU 3" },
      ],

      genders: [
        { value: "NONE", text: "TODOS" },
        { value: "FEMININO", text: "FEMININO" },
        { value: "MASCULINO", text: "MASCULINO" },
      ],

      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    userData,
    permission,
    getAge,
    formatDate,

    handleColorBloodPressure(initial, final) {
      if (parseInt(initial) >= 100 && parseInt(initial) <= 140) {
        if (parseInt(final) >= 60 && parseInt(final) <= 90) {
          return "bg-success text-white";
        }
        if (parseInt(final) >= 50 && parseInt(final) <= 59) {
          return "bg-warning text-dark";
        }
      }

      if (parseInt(initial) >= 141 && parseInt(initial) <= 179) {
        if (parseInt(final) >= 91 && parseInt(final) <= 109) {
          return "bg-warning text-dark";
        } else {
          return "bg-danger text-white";
        }
      }

      return "bg-danger text-white";
    },

    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },

    async retrieve() {
      let { user } = userData();

      this.user = user;

      this.getResidents();
    },

    async getResidents() {
      try {
        this.loading = true;
        this.residents = [];

        let {
          page,
          itemsPerPage,
          name,
          degree_of_dependence_id,
          gender,
          next_or_previous,
          date,
        } = this;

        let params = {
          page,
          itemsPerPage,
          name,
          degree_of_dependence_id,
          gender,
          next_or_previous,
          date,
        };

        const response = await api.get(
          "/rest-home/resident/dashboard/vital-signs-list",
          {
            params,
          }
        );

        const { residents, error, errors, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.filter = residents;
          this.residents = residents;
          this.total = total;
          this.errors = [];
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToResident: (id) =>
      routes.push({
        name: "resident",
        params: { id },
        query: {
          tab: "check",
          nav: "check",
        },
      }),
  },
};
</script>

<style>
.dashboard-resident-vital-signs-list .photo_url {
  width: 100px !important;
  height: 100px !important;
  object-fit: contain !important;
  border-radius: 100%;
}
</style>
